import React from 'react'
import styles from './fsu-teacher.styles'
import injectSheet from 'react-jss'

const FSUTeacher = ({ classes, Screen }) => <Screen />

export default injectSheet(styles)(FSUTeacher)
